/* unplugin-vue-components disabled */import { render } from "./ArticleDetails.vue?vue&type=template&id=20ee260d&scoped=true"
import script from "./ArticleDetails.vue?vue&type=script&lang=js"
export * from "./ArticleDetails.vue?vue&type=script&lang=js"

import "./ArticleDetails.vue?vue&type=style&index=0&id=20ee260d&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ee260d"]])

export default __exports__